import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteZonePricingPlanFormModal from 'src/features/zone/components/form/DeleteZonePricingPlanFormModal';
import UpdateZonePricingPlanFormModal from 'src/features/zone/components/form/UpdateZonePricingPlanFormModal';
import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { ZonePricingPlan } from 'src/features/zone/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellZonePricingPlanActions({ row }: CellContext<ZonePricingPlan, unknown>) {
    const { formatMessage } = useIntl();

    // Default (standard) plans cannot be edited or deleted from object assignments.
    if (row.original.is_system) return null;

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateZonePricingPlanFormModal
                        selectedZonePricingPlan={row.original}
                        semantics={{ entryName: formatMessage(pricingPlanMessages.pricingPlan).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateZonePricingPlanFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteZonePricingPlanFormModal
                        selectedZonePricingPlan={row.original}
                        semantics={{ entryName: formatMessage(pricingPlanMessages.pricingPlan).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteZonePricingPlanFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
